// extracted by mini-css-extract-plugin
export var modal = "_3x-0";